"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6998],{

/***/ 36998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gP": function() { return /* binding */ Condition; },
  "IL": function() { return /* binding */ ListingType; },
  "uB": function() { return /* binding */ ReferralStatus; },
  "eO": function() { return /* binding */ StripeStatus; },
  "Ve": function() { return /* binding */ useCalculateBookingPriceQuery; },
  "Ii": function() { return /* binding */ useCaptureOnboardingInfoMutation; },
  "qo": function() { return /* binding */ useChatChannelQuery; },
  "GV": function() { return /* binding */ useChatTokenQuery; },
  "$L": function() { return /* binding */ useCheckAccountExistsQuery; },
  "ub": function() { return /* binding */ useCheckOnboardingStatusQuery; },
  "F9": function() { return /* binding */ useCreateCheckoutMutation; },
  "S2": function() { return /* binding */ useGetCreditQuery; },
  "Cp": function() { return /* binding */ useGetReferralHistoryQuery; },
  "ML": function() { return /* binding */ useGetVerificationSessionQuery; },
  "Uo": function() { return /* binding */ useHomePageRecommendationsQuery; },
  "RN": function() { return /* binding */ useLocalityAutocompleteQuery; },
  "X8": function() { return /* binding */ useLoginWithPasswordMutation; },
  "_y": function() { return /* binding */ useLogoutMutation; },
  "vt": function() { return /* binding */ useNavigationQuery; },
  "l4": function() { return /* binding */ useRegisterMutation; },
  "ZL": function() { return /* binding */ useUploadIdDocsMutation; },
  "DK": function() { return /* binding */ useVerifyPhoneNumberMutation; }
});

// UNUSED EXPORTS: AccountType, AttributeType, AuthenticatedUserFragmentDoc, BookingDocument, BookingStatus, CalculateBookingPriceDocument, CaptureOnboardingInfoDocument, ChatChannelDocument, ChatTokenDocument, CheckAccountExistsDocument, CheckOnboardingStatusDocument, CompleteCheckoutDocument, CreateChannelDocument, CreateCheckoutDocument, CreditHistoryTable_CreditHistoryFragmentDoc, ENotLiveReason, ESuListAccountFilterEnum, ExchangeTokenDocument, GetBrandPageDocument, GetCategoryPageDocument, GetCheckoutSessionDocument, GetCommunityCategoriesDocument, GetCreditDocument, GetReferralHistoryDocument, GetReferrerDocument, GetStorePageDocument, GetVerificationSessionDocument, HomePageRecommendationsDocument, ListingCardFragmentDoc, ListingPageDocument, ListingSortDirection, ListingSortOrder, LocalityAutocompleteDocument, LoginWithPasswordDocument, LogoutDocument, NavigationCategoryRecursiveFragmentDoc, NavigationQueryDocument, Providers, RefreshJwtDocument, RegisterDocument, UploadIdDocsDocument, UserProfileDocument, VerifyEmailDocument, VerifyPhoneNumberDocument, useBookingQuery, useCompleteCheckoutMutation, useCreateChannelMutation, useExchangeTokenMutation, useGetBrandPageQuery, useGetCategoryPageQuery, useGetCheckoutSessionQuery, useGetCommunityCategoriesQuery, useGetReferrerQuery, useGetStorePageQuery, useListingPageQuery, useRefreshJwtMutation, useUserProfileQuery, useVerifyEmailMutation

// EXTERNAL MODULE: ../../node_modules/react-query/es/index.js
var es = __webpack_require__(82066);
// EXTERNAL MODULE: ./src/utils/graphql-client.ts
var graphql_client = __webpack_require__(10089);
;// CONCATENATED MODULE: ./src/generated/fetcher.ts

function fetcher(query, variables, headers) {
    return function() {
        return graphql_client/* gqlClient.request */.N.request(query, variables, headers);
    };
}

;// CONCATENATED MODULE: ./src/generated/graphql.ts


var AccountType;
(function(AccountType) {
    AccountType["B2c"] = "b2c";
    AccountType["C2c"] = "c2c";
})(AccountType || (AccountType = {}));
var AttributeType;
(function(AttributeType) {
    AttributeType["Boolean"] = "boolean";
    AttributeType["InputFloat"] = "input_float";
    AttributeType["InputInt"] = "input_int";
    AttributeType["InputString"] = "input_string";
    AttributeType["SelectMulti"] = "select_multi";
    AttributeType["SelectSingle"] = "select_single";
})(AttributeType || (AttributeType = {}));
var BookingStatus;
(function(BookingStatus) {
    BookingStatus["Approved"] = "approved";
    BookingStatus["Cancelled"] = "cancelled";
    BookingStatus["Disputed"] = "disputed";
    BookingStatus["OutForRent"] = "out_for_rent";
    BookingStatus["Paid"] = "paid";
    BookingStatus["PaymentFailed"] = "payment_failed";
    BookingStatus["PendingApproval"] = "pending_approval";
    BookingStatus["Rejected"] = "rejected";
    BookingStatus["Returned"] = "returned";
})(BookingStatus || (BookingStatus = {}));
var Condition;
(function(Condition) {
    Condition["Fair"] = "FAIR";
    Condition["Good"] = "GOOD";
    Condition["Likenew"] = "LIKENEW";
})(Condition || (Condition = {}));
var ENotLiveReason;
(function(ENotLiveReason) {
    ENotLiveReason["AccountNotApproved"] = "ACCOUNT_NOT_APPROVED";
    ENotLiveReason["AccountStripeTransfers"] = "ACCOUNT_STRIPE_TRANSFERS";
    ENotLiveReason["Disabled"] = "DISABLED";
    ENotLiveReason["NotApproved"] = "NOT_APPROVED";
    ENotLiveReason["NoImage"] = "NO_IMAGE";
})(ENotLiveReason || (ENotLiveReason = {}));
var ESuListAccountFilterEnum;
(function(ESuListAccountFilterEnum) {
    ESuListAccountFilterEnum["Disputed"] = "disputed";
    ESuListAccountFilterEnum["NeedsEnabling"] = "needs_enabling";
    ESuListAccountFilterEnum["NewSignups"] = "new_signups";
    ESuListAccountFilterEnum["None"] = "none";
    ESuListAccountFilterEnum["Popular"] = "popular";
})(ESuListAccountFilterEnum || (ESuListAccountFilterEnum = {}));
var ListingSortDirection;
(function(ListingSortDirection) {
    ListingSortDirection["Ascending"] = "ascending";
    ListingSortDirection["Descending"] = "descending";
})(ListingSortDirection || (ListingSortDirection = {}));
var ListingSortOrder;
(function(ListingSortOrder) {
    ListingSortOrder["CreatedOn"] = "createdOn";
    ListingSortOrder["ModifiedOn"] = "modifiedOn";
})(ListingSortOrder || (ListingSortOrder = {}));
var ListingType;
(function(ListingType) {
    ListingType["External"] = "external";
    ListingType["Internal"] = "internal";
})(ListingType || (ListingType = {}));
var Providers;
(function(Providers) {
    Providers["Apple"] = "apple";
    Providers["Facebook"] = "facebook";
    Providers["Google"] = "google";
    Providers["Password"] = "password";
})(Providers || (Providers = {}));
var ReferralStatus;
(function(ReferralStatus) {
    ReferralStatus["Credited"] = "credited";
    ReferralStatus["Expired"] = "expired";
    ReferralStatus["Pending"] = "pending";
})(ReferralStatus || (ReferralStatus = {}));
var StripeStatus;
(function(StripeStatus) {
    StripeStatus["Pending"] = "pending";
    StripeStatus["Unverified"] = "unverified";
    StripeStatus["Verified"] = "verified";
})(StripeStatus || (StripeStatus = {}));
var NavigationCategoryRecursiveFragmentDoc = "\n    fragment NavigationCategoryRecursive on NavigationCategory {\n  title\n  href\n  featured {\n    title\n    href\n  }\n}\n    ";
var AuthenticatedUserFragmentDoc = "\n    fragment AuthenticatedUserFragment on AuthenticatedUser {\n  _id\n  avatarURL\n  email\n  aboutMe\n  legalName {\n    firstName\n    lastName\n    verified\n  }\n  contactNumber {\n    phoneNumber\n  }\n  setup {\n    contactNumberVerified\n  }\n}\n    ";
var ListingCardFragmentDoc = "\n    fragment ListingCardFragment on Listing {\n  __typename\n  listingId\n  title\n  images {\n    thumbnailURL\n  }\n  owner: user {\n    avatarURL\n  }\n  location {\n    national\n    locality\n    state\n    postcode\n  }\n  pricing {\n    monday\n    tuesday\n    wednesday\n    thursday\n    friday\n    saturday\n    sunday\n  }\n}\n    ";
var CreditHistoryTable_CreditHistoryFragmentDoc = "\n    fragment CreditHistoryTable_CreditHistory on CreditHistory {\n  reference\n  reason\n  creditCents\n  createdOn\n}\n    ";
var NavigationQueryDocument = "\n    query NavigationQuery {\n  Navigation {\n    promoLinks {\n      title\n      href\n    }\n    categories {\n      __typename\n      title\n      href\n      featured {\n        title\n        href\n      }\n      popularBrands {\n        title\n        href\n      }\n      children {\n        ...NavigationCategoryRecursive\n        children {\n          ...NavigationCategoryRecursive\n          children {\n            ...NavigationCategoryRecursive\n          }\n        }\n      }\n    }\n  }\n}\n    ".concat(NavigationCategoryRecursiveFragmentDoc);
var useNavigationQuery = function(variables, options) {
    return (0,es.useQuery)(variables === undefined ? [
        "NavigationQuery"
    ] : [
        "NavigationQuery",
        variables
    ], fetcher(NavigationQueryDocument, variables), options);
};
useNavigationQuery.getKey = function(variables) {
    return variables === undefined ? [
        "NavigationQuery"
    ] : [
        "NavigationQuery",
        variables
    ];
};
useNavigationQuery.fetcher = function(variables, options) {
    return fetcher(NavigationQueryDocument, variables, options);
};
var LogoutDocument = "\n    mutation Logout {\n  Logout\n}\n    ";
var useLogoutMutation = function(options) {
    return (0,es.useMutation)([
        "Logout"
    ], function(variables) {
        return fetcher(LogoutDocument, variables)();
    }, options);
};
useLogoutMutation.getKey = function() {
    return [
        "Logout"
    ];
};
useLogoutMutation.fetcher = function(variables, options) {
    return fetcher(LogoutDocument, variables, options);
};
var ExchangeTokenDocument = "\n    mutation ExchangeToken($exchangeToken: String!) {\n  ExchangeToken(exchangeToken: $exchangeToken) {\n    __typename\n    ... on LoginSuccess {\n      access_token\n      refresh_token\n      user {\n        ...AuthenticatedUserFragment\n      }\n    }\n    ... on GqlError {\n      code\n      message\n    }\n  }\n}\n    ".concat(AuthenticatedUserFragmentDoc);
var useExchangeTokenMutation = function(options) {
    return (0,es.useMutation)([
        "ExchangeToken"
    ], function(variables) {
        return fetcher(ExchangeTokenDocument, variables)();
    }, options);
};
useExchangeTokenMutation.getKey = function() {
    return [
        "ExchangeToken"
    ];
};
useExchangeTokenMutation.fetcher = function(variables, options) {
    return fetcher(ExchangeTokenDocument, variables, options);
};
var LoginWithPasswordDocument = "\n    mutation LoginWithPassword($email: String!, $password: String!, $staySignedIn: Boolean!) {\n  LoginWithPassword(\n    email: $email\n    password: $password\n    staySignedIn: $staySignedIn\n  ) {\n    __typename\n    ... on LoginSuccess {\n      access_token\n      refresh_token\n      user {\n        ...AuthenticatedUserFragment\n      }\n    }\n    ... on GqlError {\n      code\n      message\n    }\n  }\n}\n    ".concat(AuthenticatedUserFragmentDoc);
var useLoginWithPasswordMutation = function(options) {
    return (0,es.useMutation)([
        "LoginWithPassword"
    ], function(variables) {
        return fetcher(LoginWithPasswordDocument, variables)();
    }, options);
};
useLoginWithPasswordMutation.getKey = function() {
    return [
        "LoginWithPassword"
    ];
};
useLoginWithPasswordMutation.fetcher = function(variables, options) {
    return fetcher(LoginWithPasswordDocument, variables, options);
};
var RefreshJwtDocument = "\n    mutation RefreshJWT($refreshToken: String) {\n  RefreshJWT(refreshToken: $refreshToken) {\n    __typename\n    ... on LoginSuccess {\n      access_token\n      refresh_token\n      user {\n        ...AuthenticatedUserFragment\n      }\n    }\n    ... on GqlError {\n      code\n      message\n    }\n  }\n}\n    ".concat(AuthenticatedUserFragmentDoc);
var useRefreshJwtMutation = function(options) {
    return (0,es.useMutation)([
        "RefreshJWT"
    ], function(variables) {
        return fetcher(RefreshJwtDocument, variables)();
    }, options);
};
useRefreshJwtMutation.getKey = function() {
    return [
        "RefreshJWT"
    ];
};
useRefreshJwtMutation.fetcher = function(variables, options) {
    return fetcher(RefreshJwtDocument, variables, options);
};
var RegisterDocument = "\n    mutation Register($email: String!, $password: String!, $lastName: String!, $firstName: String!, $mobileNumber: ContactNumberInput!, $referrerId: String) {\n  Register(\n    email: $email\n    password: $password\n    lastName: $lastName\n    firstName: $firstName\n    mobileNumber: $mobileNumber\n    referrerUserId: $referrerId\n    accountType: c2c\n  ) {\n    __typename\n    ... on AuthenticatedUser {\n      ...AuthenticatedUserFragment\n      contactNumber {\n        _id\n      }\n    }\n    ... on InputValidationErrors {\n      errors {\n        field\n        message\n      }\n    }\n  }\n}\n    ".concat(AuthenticatedUserFragmentDoc);
var useRegisterMutation = function(options) {
    return (0,es.useMutation)([
        "Register"
    ], function(variables) {
        return fetcher(RegisterDocument, variables)();
    }, options);
};
useRegisterMutation.getKey = function() {
    return [
        "Register"
    ];
};
useRegisterMutation.fetcher = function(variables, options) {
    return fetcher(RegisterDocument, variables, options);
};
var VerifyPhoneNumberDocument = "\n    mutation VerifyPhoneNumber($verificationCode: String!, $contactNumberId: String!) {\n  VerifyPhoneNumber(\n    verificationCode: $verificationCode\n    contactNumberId: $contactNumberId\n  ) {\n    __typename\n    ... on SuccessfulState {\n      success\n    }\n    ... on GqlError {\n      code\n      message\n    }\n  }\n}\n    ";
var useVerifyPhoneNumberMutation = function(options) {
    return (0,es.useMutation)([
        "VerifyPhoneNumber"
    ], function(variables) {
        return fetcher(VerifyPhoneNumberDocument, variables)();
    }, options);
};
useVerifyPhoneNumberMutation.getKey = function() {
    return [
        "VerifyPhoneNumber"
    ];
};
useVerifyPhoneNumberMutation.fetcher = function(variables, options) {
    return fetcher(VerifyPhoneNumberDocument, variables, options);
};
var CheckAccountExistsDocument = "\n    query CheckAccountExists($email: String!) {\n  CheckAccountExists(email: $email) {\n    exists\n    provider\n  }\n}\n    ";
var useCheckAccountExistsQuery = function(variables, options) {
    return (0,es.useQuery)([
        "CheckAccountExists",
        variables
    ], fetcher(CheckAccountExistsDocument, variables), options);
};
useCheckAccountExistsQuery.getKey = function(variables) {
    return [
        "CheckAccountExists",
        variables, 
    ];
};
useCheckAccountExistsQuery.fetcher = function(variables, options) {
    return fetcher(CheckAccountExistsDocument, variables, options);
};
var CompleteCheckoutDocument = "\n    mutation CompleteCheckout($checkoutSessionId: String!, $message: String) {\n  completeCheckout: CompleteCheckout(\n    checkoutId: $checkoutSessionId\n    message: $message\n  ) {\n    __typename\n    ... on Booking {\n      _id\n    }\n    ... on GqlError {\n      code\n      message\n    }\n  }\n}\n    ";
var useCompleteCheckoutMutation = function(options) {
    return (0,es.useMutation)([
        "CompleteCheckout"
    ], function(variables) {
        return fetcher(CompleteCheckoutDocument, variables)();
    }, options);
};
useCompleteCheckoutMutation.getKey = function() {
    return [
        "CompleteCheckout"
    ];
};
useCompleteCheckoutMutation.fetcher = function(variables, options) {
    return fetcher(CompleteCheckoutDocument, variables, options);
};
var BookingDocument = "\n    query Booking($bookingId: String!) {\n  booking: Booking(bookingId: $bookingId) {\n    _id\n    seeker: seekerUser {\n      _id\n    }\n    listing {\n      listingId\n      title\n      location {\n        locality\n        postcode\n      }\n      images {\n        thumbnailURL\n      }\n      owner: user {\n        _id\n        legalName {\n          firstName\n          verified\n        }\n        avatarURL\n      }\n    }\n    totalOfferPrice\n    refundableBondPrice\n    dateStart\n    dateEnd\n  }\n}\n    ";
var useBookingQuery = function(variables, options) {
    return (0,es.useQuery)([
        "Booking",
        variables
    ], fetcher(BookingDocument, variables), options);
};
useBookingQuery.getKey = function(variables) {
    return [
        "Booking",
        variables
    ];
};
useBookingQuery.fetcher = function(variables, options) {
    return fetcher(BookingDocument, variables, options);
};
var GetCheckoutSessionDocument = "\n    query GetCheckoutSession($checkoutSessionId: String!) {\n  checkout: Checkout(_id: $checkoutSessionId) {\n    _id\n    listing {\n      listingId\n      title\n      location {\n        locality\n        state\n      }\n      images {\n        thumbnailURL\n      }\n      owner: user {\n        _id\n        legalName {\n          firstName\n          verified\n        }\n        avatarURL\n      }\n    }\n    seeker: seekerUser {\n      _id\n      email\n      legalName {\n        verified\n      }\n    }\n    totalOfferPrice\n    refundableBondPrice\n    dateStart\n    dateEnd\n    setupIntentSecret\n    discount {\n      creditCents\n    }\n  }\n}\n    ";
var useGetCheckoutSessionQuery = function(variables, options) {
    return (0,es.useQuery)([
        "GetCheckoutSession",
        variables
    ], fetcher(GetCheckoutSessionDocument, variables), options);
};
useGetCheckoutSessionQuery.getKey = function(variables) {
    return [
        "GetCheckoutSession",
        variables, 
    ];
};
useGetCheckoutSessionQuery.fetcher = function(variables, options) {
    return fetcher(GetCheckoutSessionDocument, variables, options);
};
var HomePageRecommendationsDocument = "\n    query HomePageRecommendations {\n  HomePageRecommendations {\n    heading\n    listings {\n      ...ListingCardFragment\n    }\n  }\n}\n    ".concat(ListingCardFragmentDoc);
var useHomePageRecommendationsQuery = function(variables, options) {
    return (0,es.useQuery)(variables === undefined ? [
        "HomePageRecommendations"
    ] : [
        "HomePageRecommendations",
        variables
    ], fetcher(HomePageRecommendationsDocument, variables), options);
};
useHomePageRecommendationsQuery.getKey = function(variables) {
    return variables === undefined ? [
        "HomePageRecommendations"
    ] : [
        "HomePageRecommendations",
        variables
    ];
};
useHomePageRecommendationsQuery.fetcher = function(variables, options) {
    return fetcher(HomePageRecommendationsDocument, variables, options);
};
var CheckOnboardingStatusDocument = "\n    query CheckOnboardingStatus {\n  OnboardingStatus: CheckOnboardingStatus {\n    status\n    profile {\n      state\n      city\n      postalCode\n      addressLine1\n      dateOfBirthYear\n      dateOfBirthMonth\n      dateOfBirthDay\n      lastName\n      firstName\n    }\n    errors {\n      code\n      requirement\n      reason\n    }\n  }\n}\n    ";
var useCheckOnboardingStatusQuery = function(variables, options) {
    return (0,es.useQuery)(variables === undefined ? [
        "CheckOnboardingStatus"
    ] : [
        "CheckOnboardingStatus",
        variables
    ], fetcher(CheckOnboardingStatusDocument, variables), options);
};
useCheckOnboardingStatusQuery.getKey = function(variables) {
    return variables === undefined ? [
        "CheckOnboardingStatus"
    ] : [
        "CheckOnboardingStatus",
        variables
    ];
};
useCheckOnboardingStatusQuery.fetcher = function(variables, options) {
    return fetcher(CheckOnboardingStatusDocument, variables, options);
};
var GetVerificationSessionDocument = "\n    query GetVerificationSession($checkoutSessionId: String) {\n  verificationSession: CreateVerificationSession(\n    checkoutSessionId: $checkoutSessionId\n  ) {\n    url\n    clientSecret\n  }\n}\n    ";
var useGetVerificationSessionQuery = function(variables, options) {
    return (0,es.useQuery)(variables === undefined ? [
        "GetVerificationSession"
    ] : [
        "GetVerificationSession",
        variables
    ], fetcher(GetVerificationSessionDocument, variables), options);
};
useGetVerificationSessionQuery.getKey = function(variables) {
    return variables === undefined ? [
        "GetVerificationSession"
    ] : [
        "GetVerificationSession",
        variables
    ];
};
useGetVerificationSessionQuery.fetcher = function(variables, options) {
    return fetcher(GetVerificationSessionDocument, variables, options);
};
var CaptureOnboardingInfoDocument = "\n    mutation CaptureOnboardingInfo($state: String!, $city: String!, $postalCode: String!, $addressLine1: String!, $dateOfBirthYear: Int!, $dateOfBirthMonth: Int!, $dateOfBirthDay: Int!, $lastName: String!, $firstName: String!) {\n  CaptureOnboardingInformation(\n    state: $state\n    city: $city\n    postalCode: $postalCode\n    addressLine1: $addressLine1\n    dateOfBirthYear: $dateOfBirthYear\n    dateOfBirthMonth: $dateOfBirthMonth\n    dateOfBirthDay: $dateOfBirthDay\n    lastName: $lastName\n    firstName: $firstName\n  ) {\n    __typename\n    errors {\n      code\n      reason\n      requirement\n    }\n  }\n}\n    ";
var useCaptureOnboardingInfoMutation = function(options) {
    return (0,es.useMutation)([
        "CaptureOnboardingInfo"
    ], function(variables) {
        return fetcher(CaptureOnboardingInfoDocument, variables)();
    }, options);
};
useCaptureOnboardingInfoMutation.getKey = function() {
    return [
        "CaptureOnboardingInfo"
    ];
};
useCaptureOnboardingInfoMutation.fetcher = function(variables, options) {
    return fetcher(CaptureOnboardingInfoDocument, variables, options);
};
var UploadIdDocsDocument = "\n    mutation UploadIDDocs($idDocFrontKey: String!, $idDocBackKey: String) {\n  UploadIdentityDocuments(front: $idDocFrontKey, back: $idDocBackKey) {\n    errors {\n      code\n      reason\n      requirement\n    }\n  }\n}\n    ";
var useUploadIdDocsMutation = function(options) {
    return (0,es.useMutation)([
        "UploadIDDocs"
    ], function(variables) {
        return fetcher(UploadIdDocsDocument, variables)();
    }, options);
};
useUploadIdDocsMutation.getKey = function() {
    return [
        "UploadIDDocs"
    ];
};
useUploadIdDocsMutation.fetcher = function(variables, options) {
    return fetcher(UploadIdDocsDocument, variables, options);
};
var CreateCheckoutDocument = "\n    mutation CreateCheckout($listingId: String!, $dateStart: DateTime!, $dateEnd: DateTime!) {\n  CreateCheckout(listingId: $listingId, dateStart: $dateStart, dateEnd: $dateEnd) {\n    __typename\n    ... on Checkout {\n      _id\n    }\n    ... on GqlError {\n      code\n      message\n    }\n  }\n}\n    ";
var useCreateCheckoutMutation = function(options) {
    return (0,es.useMutation)([
        "CreateCheckout"
    ], function(variables) {
        return fetcher(CreateCheckoutDocument, variables)();
    }, options);
};
useCreateCheckoutMutation.getKey = function() {
    return [
        "CreateCheckout"
    ];
};
useCreateCheckoutMutation.fetcher = function(variables, options) {
    return fetcher(CreateCheckoutDocument, variables, options);
};
var CalculateBookingPriceDocument = "\n    query CalculateBookingPrice($listingId: String!, $dateStart: String!, $dateEnd: String!) {\n  CalculateBookingPrice(\n    listingId: $listingId\n    startDate: $dateStart\n    endDate: $dateEnd\n  ) {\n    totalPrice\n  }\n}\n    ";
var useCalculateBookingPriceQuery = function(variables, options) {
    return (0,es.useQuery)([
        "CalculateBookingPrice",
        variables
    ], fetcher(CalculateBookingPriceDocument, variables), options);
};
useCalculateBookingPriceQuery.getKey = function(variables) {
    return [
        "CalculateBookingPrice",
        variables, 
    ];
};
useCalculateBookingPriceQuery.fetcher = function(variables, options) {
    return fetcher(CalculateBookingPriceDocument, variables, options);
};
var ListingPageDocument = "\n    query ListingPage($listingId: String!) {\n  listing: Listing(listingId: $listingId) {\n    __typename\n    listingId\n    title\n    description\n    approved\n    keywords\n    images {\n      sortOrder\n      thumbnailURL\n      heroURL\n    }\n    owner: user {\n      _id\n      accountId\n      avatarURL\n      legalName {\n        firstName\n        lastName\n        verified\n      }\n    }\n    category {\n      categoryId\n      categoryName\n      urlSlug\n      breadcrumb {\n        categoryName\n        urlSlug\n      }\n    }\n    bondPrice\n    pricing {\n      monday\n      tuesday\n      wednesday\n      thursday\n      friday\n      saturday\n      sunday\n    }\n    unavailableDates {\n      unavailableDates\n      unavailableDaysOfWeek\n    }\n    location {\n      national\n      state\n      locality\n      postcode\n    }\n    brand\n    attributes {\n      attributeId\n      attributeType\n      attributeName\n      valueInt\n      valueFloat\n      valueString\n      valueStringArray\n      valueBoolean\n    }\n    recommendations {\n      heading\n      listings {\n        ...ListingCardFragment\n      }\n    }\n    ... on InternalListing {\n      condition\n      rules\n    }\n    ... on ExternalListing {\n      externalURL\n    }\n  }\n}\n    ".concat(ListingCardFragmentDoc);
var useListingPageQuery = function(variables, options) {
    return (0,es.useQuery)([
        "ListingPage",
        variables
    ], fetcher(ListingPageDocument, variables), options);
};
useListingPageQuery.getKey = function(variables) {
    return [
        "ListingPage",
        variables
    ];
};
useListingPageQuery.fetcher = function(variables, options) {
    return fetcher(ListingPageDocument, variables, options);
};
var GetReferralHistoryDocument = "\n    query GetReferralHistory {\n  GetReferralHistory {\n    referredUserName\n    creditAmountCents\n    status\n    createdAt\n  }\n}\n    ";
var useGetReferralHistoryQuery = function(variables, options) {
    return (0,es.useQuery)(variables === undefined ? [
        "GetReferralHistory"
    ] : [
        "GetReferralHistory",
        variables
    ], fetcher(GetReferralHistoryDocument, variables), options);
};
useGetReferralHistoryQuery.getKey = function(variables) {
    return variables === undefined ? [
        "GetReferralHistory"
    ] : [
        "GetReferralHistory",
        variables
    ];
};
useGetReferralHistoryQuery.fetcher = function(variables, options) {
    return fetcher(GetReferralHistoryDocument, variables, options);
};
var GetBrandPageDocument = "\n    query GetBrandPage($slug: String!) {\n  GetBrandPage(slug: $slug) {\n    brands\n  }\n}\n    ";
var useGetBrandPageQuery = function(variables, options) {
    return (0,es.useQuery)([
        "GetBrandPage",
        variables
    ], fetcher(GetBrandPageDocument, variables), options);
};
useGetBrandPageQuery.getKey = function(variables) {
    return [
        "GetBrandPage",
        variables, 
    ];
};
useGetBrandPageQuery.fetcher = function(variables, options) {
    return fetcher(GetBrandPageDocument, variables, options);
};
var GetCategoryPageDocument = "\n    query GetCategoryPage($slug: String!) {\n  CategoryPage(urlSlug: $slug) {\n    categoryId\n    categoryName\n    urlSlug\n    breadcrumb {\n      categoryId\n      categoryName\n      urlSlug\n    }\n  }\n}\n    ";
var useGetCategoryPageQuery = function(variables, options) {
    return (0,es.useQuery)([
        "GetCategoryPage",
        variables
    ], fetcher(GetCategoryPageDocument, variables), options);
};
useGetCategoryPageQuery.getKey = function(variables) {
    return [
        "GetCategoryPage",
        variables, 
    ];
};
useGetCategoryPageQuery.fetcher = function(variables, options) {
    return fetcher(GetCategoryPageDocument, variables, options);
};
var GetCommunityCategoriesDocument = "\n    query GetCommunityCategories($postcodes: [String!]!) {\n  CommunityCategories(postcodes: $postcodes) {\n    categoryName\n    urlSlug\n  }\n}\n    ";
var useGetCommunityCategoriesQuery = function(variables, options) {
    return (0,es.useQuery)([
        "GetCommunityCategories",
        variables
    ], fetcher(GetCommunityCategoriesDocument, variables), options);
};
useGetCommunityCategoriesQuery.getKey = function(variables) {
    return [
        "GetCommunityCategories",
        variables, 
    ];
};
useGetCommunityCategoriesQuery.fetcher = function(variables, options) {
    return fetcher(GetCommunityCategoriesDocument, variables, options);
};
var GetStorePageDocument = "\n    query GetStorePage($accountId: String!) {\n  StorePage(accountId: $accountId) {\n    accountId\n    accountName\n  }\n}\n    ";
var useGetStorePageQuery = function(variables, options) {
    return (0,es.useQuery)([
        "GetStorePage",
        variables
    ], fetcher(GetStorePageDocument, variables), options);
};
useGetStorePageQuery.getKey = function(variables) {
    return [
        "GetStorePage",
        variables, 
    ];
};
useGetStorePageQuery.fetcher = function(variables, options) {
    return fetcher(GetStorePageDocument, variables, options);
};
var LocalityAutocompleteDocument = "\n    query LocalityAutocomplete($localityPartial: String!) {\n  LocalityAutocomplete(localityPartial: $localityPartial) {\n    postcode\n    locality\n    state\n    latitude\n    longitude\n  }\n}\n    ";
var useLocalityAutocompleteQuery = function(variables, options) {
    return (0,es.useQuery)([
        "LocalityAutocomplete",
        variables
    ], fetcher(LocalityAutocompleteDocument, variables), options);
};
useLocalityAutocompleteQuery.getKey = function(variables) {
    return [
        "LocalityAutocomplete",
        variables, 
    ];
};
useLocalityAutocompleteQuery.fetcher = function(variables, options) {
    return fetcher(LocalityAutocompleteDocument, variables, options);
};
var VerifyEmailDocument = "\n    mutation VerifyEmail($token: String!) {\n  VerifyEmail(token: $token)\n}\n    ";
var useVerifyEmailMutation = function(options) {
    return (0,es.useMutation)([
        "VerifyEmail"
    ], function(variables) {
        return fetcher(VerifyEmailDocument, variables)();
    }, options);
};
useVerifyEmailMutation.getKey = function() {
    return [
        "VerifyEmail"
    ];
};
useVerifyEmailMutation.fetcher = function(variables, options) {
    return fetcher(VerifyEmailDocument, variables, options);
};
var UserProfileDocument = "\n    query UserProfile($userId: String!) {\n  user: User(userId: $userId) {\n    accountId\n    createDate\n    avatarURL\n    aboutMe\n    legalName {\n      firstName\n      verified\n    }\n  }\n}\n    ";
var useUserProfileQuery = function(variables, options) {
    return (0,es.useQuery)([
        "UserProfile",
        variables
    ], fetcher(UserProfileDocument, variables), options);
};
useUserProfileQuery.getKey = function(variables) {
    return [
        "UserProfile",
        variables
    ];
};
useUserProfileQuery.fetcher = function(variables, options) {
    return fetcher(UserProfileDocument, variables, options);
};
var ChatChannelDocument = "\n    query ChatChannel($channelId: String!) {\n  ChatChannel(channelId: $channelId) {\n    __typename\n    ... on ChatChannel {\n      ctaText\n      isOwner\n      isSeeker\n      listingId\n      listing {\n        listingId\n        title\n        user {\n          legalName {\n            firstName\n          }\n          avatarURL\n        }\n        images {\n          thumbnailURL\n        }\n      }\n      seekerUser {\n        _id\n        createDate\n        avatarURL\n        legalName {\n          firstName\n          lastName\n          verified\n        }\n      }\n      bookingId\n      booking {\n        dateStart\n        dateEnd\n      }\n    }\n    ... on GenericError {\n      errorCode\n      errorMessage\n    }\n  }\n}\n    ";
var useChatChannelQuery = function(variables, options) {
    return (0,es.useQuery)([
        "ChatChannel",
        variables
    ], fetcher(ChatChannelDocument, variables), options);
};
useChatChannelQuery.getKey = function(variables) {
    return [
        "ChatChannel",
        variables
    ];
};
useChatChannelQuery.fetcher = function(variables, options) {
    return fetcher(ChatChannelDocument, variables, options);
};
var CreateChannelDocument = "\n    mutation CreateChannel($listingId: String!) {\n  CreateChannel(listingId: $listingId) {\n    __typename\n    ... on ChatChannelCreateSuccess {\n      channelId\n    }\n    ... on GenericError {\n      errorCode\n      errorMessage\n    }\n  }\n}\n    ";
var useCreateChannelMutation = function(options) {
    return (0,es.useMutation)([
        "CreateChannel"
    ], function(variables) {
        return fetcher(CreateChannelDocument, variables)();
    }, options);
};
useCreateChannelMutation.getKey = function() {
    return [
        "CreateChannel"
    ];
};
useCreateChannelMutation.fetcher = function(variables, options) {
    return fetcher(CreateChannelDocument, variables, options);
};
var ChatTokenDocument = "\n    query ChatToken {\n  ChatToken {\n    __typename\n    ... on ChatToken {\n      token\n    }\n    ... on GenericError {\n      errorCode\n      errorMessage\n    }\n  }\n}\n    ";
var useChatTokenQuery = function(variables, options) {
    return (0,es.useQuery)(variables === undefined ? [
        "ChatToken"
    ] : [
        "ChatToken",
        variables
    ], fetcher(ChatTokenDocument, variables), options);
};
useChatTokenQuery.getKey = function(variables) {
    return variables === undefined ? [
        "ChatToken"
    ] : [
        "ChatToken",
        variables
    ];
};
useChatTokenQuery.fetcher = function(variables, options) {
    return fetcher(ChatTokenDocument, variables, options);
};
var GetCreditDocument = "\n    query GetCredit {\n  GetCredit {\n    creditBalance\n    creditHistory {\n      ...CreditHistoryTable_CreditHistory\n    }\n  }\n}\n    ".concat(CreditHistoryTable_CreditHistoryFragmentDoc);
var useGetCreditQuery = function(variables, options) {
    return (0,es.useQuery)(variables === undefined ? [
        "GetCredit"
    ] : [
        "GetCredit",
        variables
    ], fetcher(GetCreditDocument, variables), options);
};
useGetCreditQuery.getKey = function(variables) {
    return variables === undefined ? [
        "GetCredit"
    ] : [
        "GetCredit",
        variables
    ];
};
useGetCreditQuery.fetcher = function(variables, options) {
    return fetcher(GetCreditDocument, variables, options);
};
var GetReferrerDocument = "\n    query GetReferrer($referrerId: String!) {\n  Referrer: User(userId: $referrerId) {\n    _id\n  }\n}\n    ";
var useGetReferrerQuery = function(variables, options) {
    return (0,es.useQuery)([
        "GetReferrer",
        variables
    ], fetcher(GetReferrerDocument, variables), options);
};
useGetReferrerQuery.getKey = function(variables) {
    return [
        "GetReferrer",
        variables
    ];
};
useGetReferrerQuery.fetcher = function(variables, options) {
    return fetcher(GetReferrerDocument, variables, options);
};


/***/ }),

/***/ 11603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ HandledGQLErrorCodes; },
/* harmony export */   "l": function() { return /* binding */ SanitizedGQLError; }
/* harmony export */ });
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent1, args1, Class1) {
    if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _wrapNativeSuper(Class2) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class2);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var HandledGQLErrorCodes;
(function(HandledGQLErrorCodes) {
    HandledGQLErrorCodes["UNAUTHENTICATED"] = "UNAUTHENTICATED";
    HandledGQLErrorCodes["FORBIDDEN"] = "FORBIDDEN";
    HandledGQLErrorCodes["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
})(HandledGQLErrorCodes || (HandledGQLErrorCodes = {}));
var DEFAULT_ERROR_MESSAGE = "An unexpected error occurred. Please try again later.";
var ERROR_MESSAGE_MAP = {
    INTERNAL_SERVER_ERROR: DEFAULT_ERROR_MESSAGE,
    UNAUTHENTICATED: "You must be logged in to perform this action.",
    FORBIDDEN: "You do not have permission to perform this action."
};
var SanitizedGQLError = /*#__PURE__*/ function(Error) {
    "use strict";
    _inherits(SanitizedGQLError, Error);
    var _super = _createSuper(SanitizedGQLError);
    function SanitizedGQLError(error) {
        _classCallCheck(this, SanitizedGQLError);
        var _this;
        var code = error[0].extensions.code;
        var _code;
        _this = _super.call(this, (_code = ERROR_MESSAGE_MAP[code]) !== null && _code !== void 0 ? _code : DEFAULT_ERROR_MESSAGE);
        _this.name = "SanitizedGQLError";
        _this.code = code;
        _this.originalMessage = error[0].message;
        return _this;
    }
    var _proto = SanitizedGQLError.prototype;
    _proto.getDetails = function getDetails() {
        return {
            name: this.name,
            code: this.code,
            message: this.message,
            originalMessage: this.originalMessage
        };
    };
    return SanitizedGQLError;
}(_wrapNativeSuper(Error));


/***/ }),

/***/ 10089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ gqlClient; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12483);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23848);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _types_errors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11603);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var gqlClient = {
    headers: new Headers(),
    request: function request(query, variables, requestHeaders) {
        return _asyncToGenerator(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, res, ref1, data, errors, sanitizedError, session;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        _ctx.next = 3;
                        return fetch(" https://api.releaseit.com.au/graphql", {
                            method: "POST",
                            credentials: "include",
                            headers: _objectSpread({
                                "Content-Type": "application/json"
                            }, Object.fromEntries(this.headers), requestHeaders),
                            body: JSON.stringify({
                                query: query,
                                variables: variables
                            })
                        });
                    case 3:
                        res = _ctx.sent;
                        if (!(!res.ok || !((ref = res.headers.get("content-type")) === null || ref === void 0 ? void 0 : ref.includes("application/json")))) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("An unexpected error occurred. Please try again.");
                    case 6:
                        _ctx.next = 8;
                        return res.json();
                    case 8:
                        ref1 = _ctx.sent;
                        data = ref1.data;
                        errors = ref1.errors;
                        if (!errors) {
                            _ctx.next = 22;
                            break;
                        }
                        sanitizedError = new _types_errors__WEBPACK_IMPORTED_MODULE_2__/* .SanitizedGQLError */ .l(errors);
                        if (!(sanitizedError.code === _types_errors__WEBPACK_IMPORTED_MODULE_2__/* .HandledGQLErrorCodes.UNAUTHENTICATED */ .S.UNAUTHENTICATED)) {
                            _ctx.next = 20;
                            break;
                        }
                        _ctx.next = 16;
                        return (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.getSession)();
                    case 16:
                        session = _ctx.sent;
                        if (!(session && !session.error)) {
                            _ctx.next = 20;
                            break;
                        }
                        this.headers.set("authorization", "Bearer ".concat(session.accessToken));
                        return _ctx.abrupt("return", this.request(query, variables, requestHeaders));
                    case 20:
                        // We don't really care about auth error, just unexpected ones
                        if (sanitizedError.code === "INTERNAL_SERVER_ERROR") {
                            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_3__/* .captureException */ .Tb(sanitizedError, {
                                extra: _objectSpread({
                                    query: query,
                                    variables: variables
                                }, sanitizedError.getDetails())
                            });
                        }
                        throw sanitizedError;
                    case 22:
                        return _ctx.abrupt("return", data);
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, this);
        })).apply(this);
    }
};


/***/ })

}]);